export const CASINOS = [
  {
    id: 'spinland',
    name: 'Spinland',
    logo: '/logos/Spinland.png',
    affiliateLink:
      'https://media1.casimbaaff.com/redirect.aspx?pid=48778&lpid=213&bid=1617&subid=Spinland-SLUK12&clickid=w1fd37645c83a11be2253a7a61ef89c8&utm_source=londoncasinodeals&utm_medium=affiliate&utm_campaign=spinland-uk-deals&utm_content=top-card&utm_term=spinland-casino',
    rating: 4.7,
    ratingLabel: '4.7 / 5',
    bonusHeadline: 'Up to £200 Welcome Bonus',
    bonusDetails: '100% match up to £200 on your first deposit',
    description:
      'Spinland is a UKGC-licensed casino packed with hundreds of top slots, live dealer tables, and a generous welcome package. Lightning-fast withdrawals and round-the-clock support make it a firm favourite among UK players.',
    badges: ['UKGC Licensed', 'Fast Withdrawals', '500+ Slots', 'Live Casino', 'Mobile Ready'],
    highlights: [
      'Instant withdrawals via PayPal & bank transfer',
      'Regular reload bonuses and free spin drops',
      'Full mobile-optimised experience',
    ],
    licence: 'UK Gambling Commission',
    minDeposit: '£10',
    reviewSlug: '/welcome-bonuses#spinland',
    featured: false,
    order: 1,
  },
  {
    id: 'karamba',
    name: 'Karamba',
    logo: '/logos/Karamba.png',
    affiliateLink:
      'https://go.karambaaffiliates.com/visit/?bta=40838&nci=6499&utm_campaign=karamba-uk-compare&afp=w1fd37645c83a11be2253a7a61ef89c8&utm_source=londoncasinodeals&utm_medium=comparison&utm_content=card-mid&utm_term=karamba-slots',
    rating: 4.5,
    ratingLabel: '4.5 / 5',
    bonusHeadline: '100% up to £200 + 100 Free Spins',
    bonusDetails: 'Claim your first-deposit bonus plus 100 free spins on selected slots',
    description:
      'Karamba has been serving UK players since 2005. The site features a huge catalogue of slots and table games, flexible banking options, and an award-winning customer service team available seven days a week.',
    badges: ['Est. 2005', 'UKGC Licensed', '100 Free Spins', 'Award-Winning Support', 'Multi-Currency'],
    highlights: [
      'Over 700 casino games from top providers',
      '100 free spins included in welcome offer',
      'Trusted brand with a long UK track record',
    ],
    licence: 'UK Gambling Commission',
    minDeposit: '£10',
    reviewSlug: '/welcome-bonuses#karamba',
    featured: false,
    order: 2,
  },
  {
    id: '247bet',
    name: '247Bet',
    logo: '/logos/247Bet.png',
    affiliateLink:
      'https://media1.casimbaaff.com/redirect.aspx?pid=52782&lpid=285&bid=1713&subid=247Bet-SLUK12&clickid=w1fd37645c83a11be2253a7a61ef89c8&utm_source=londoncasinodeals&utm_medium=affiliate&utm_campaign=247bet-uk-promo&utm_content=list-card&utm_term=247bet-uk',
    rating: 4.4,
    ratingLabel: '4.4 / 5',
    bonusHeadline: 'Welcome Bonus Package Available',
    bonusDetails: 'Exclusive bonus offer for new UK players — check site for latest terms',
    description:
      '247Bet delivers non-stop casino action with a full sportsbook alongside its casino offering. UK-licensed and regulated, it caters to players who want slots, live casino, and sports betting under one roof.',
    badges: ['UKGC Licensed', 'Sports & Casino', '24/7 Support', 'New Player Offer', 'Secure Banking'],
    highlights: [
      'Combined sports betting and casino on one account',
      '24/7 customer support via live chat',
      'Wide range of payment methods including e-wallets',
    ],
    licence: 'UK Gambling Commission',
    minDeposit: '£10',
    reviewSlug: '/welcome-bonuses#247bet',
    featured: false,
    order: 3,
  },
];
